import {CanMatchFn} from '@angular/router';

const allowedFixtureStates = new Set(['settings', 'widget-launcher']);
const chatbotSettingsPathPattern = /^\/ai\/chatbots\/[^/]+$/;

export function isChatbotSettingsVisualFixtureUrl(href: string): boolean {
  const url = new URL(href);
  const isLocalHost = ['localhost', '127.0.0.1', '[::1]', '::1'].includes(url.hostname);
  const fixtureState = url.searchParams.get('chatbotSettingsVisualFixture') || '';

  return isLocalHost && chatbotSettingsPathPattern.test(url.pathname) && allowedFixtureStates.has(fixtureState);
}

export const chatbotSettingsVisualFixtureCanMatch: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location) return false;

  return isChatbotSettingsVisualFixtureUrl(window.location.href);
};
